import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Credits from './Credits';
import HomePage from './HomePage';
import CityPage from './CityPage';
import Puzzles from './Puzzles';
import './index.css';
import { BrowserRouter, Route, Switch } from 'react-router-dom'

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route path="/credits" render={ (props) => {return (<App ><Credits /></App>); }} />
      <Route path="/puzzles" render={ (props) => {return (<App ><Puzzles /></App>); }} />
      <Route path="/city-:citySlug" render={ (props) => {return (<App ><CityPage citySlug={props.match.params.citySlug} /></App>); }} />
      <Route path="/" render={ (props) => {return (<App ><HomePage /></App>); }} />
    </Switch>
  </BrowserRouter>,
  document.getElementById('root')
);
//<Route path="/credits" component={Credits} />



// WEBPACK FOOTER //
// ./src/index.js